import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT || 'https://api.nextdns.io',
  withCredentials: true,
});
